import { Component, OnInit } from '@angular/core';
import { DocumentCategoryService } from 'app/fiscalia/service/repository/document-category.service';

@Component({
  selector: 'repository-explorer',
  templateUrl: './explorer.component.html',
  styleUrls: ['./explorer.component.scss']
})
export class RepositoryExplorerComponent implements OnInit {

  loading: boolean = false;
  constructor(private documentCategoryService: DocumentCategoryService) { }

  ngOnInit() {
   this.documentCategoryService.loadingSubject.subscribe( loading => this.loading = loading)
  }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/explorer/explorer.component.ts